import React from "react"

const basePositions = [
  ["P", 50, 52], ["C", 50, 88], ["1B", 75, 54], ["2B", 65, 36],
  ["3B", 25, 54], ["SS", 35, 36], ["LF", 15, 19], ["RF", 85, 19],
]

export function baseballPositions(hasFourthOutfielder = false) {
  const outfield = hasFourthOutfielder ? [["LC", 36, 14], ["RC", 64, 14]] : [["CF", 50, 10]]
  return [...basePositions, ...outfield]
}

export function BaseballDiamond({ assignments, players, selectedPosition, onSelect, hasFourthOutfielder, readOnly = false }) {
  const playerById = new Map(players.map(player => [player.id, player]))

  return <div className={`baseball-field ${readOnly ? "baseball-field--readonly" : ""}`} aria-label={readOnly ? "Baseball field" : "Interactive baseball field"}>
    <div className="baseball-field__grass-lines" />
    <div className="baseball-field__infield" />
    <div className="baseball-field__basepaths" />
    <span className="baseball-field__mound" />
    <span className="baseball-field__base baseball-field__base--home" />
    <span className="baseball-field__base baseball-field__base--first" />
    <span className="baseball-field__base baseball-field__base--second" />
    <span className="baseball-field__base baseball-field__base--third" />
    {baseballPositions(hasFourthOutfielder).map(([position, x, y]) => {
      const player = playerById.get(assignments.get(position))
      const active = selectedPosition === position
      const Marker = readOnly ? "div" : "button"
      return <Marker
        {...(readOnly ? {} : { type: "button", onClick: () => onSelect(position), "aria-pressed": active })}
        key={position}
        className={`field-position ${player ? "field-position--assigned" : ""} ${active ? "field-position--active" : ""}`}
        style={{ left: `${x}%`, top: `${y}%` }}
        aria-label={`${position}: ${player ? `${player.first_name} ${player.last_name || ""}` : "unassigned"}`}
      >
        {player ? <><strong>{shortName(player)}</strong><small>{player.jersey_number != null ? `#${player.jersey_number}` : position}</small></> : <strong>{position}</strong>}
      </Marker>
    })}
  </div>
}

function shortName(player) {
  const name = `${player.first_name}${player.last_name ? ` ${player.last_name[0]}.` : ""}`
  return name.length > 11 ? `${name.slice(0, 10)}…` : name
}
